import { createContext } from "react";

/** Field errors by path ("name", "rooms.0.name"), as the API's 422 reports them. */
export type FieldErrors = Record<string, string>;

/**
 * A form's errors, so each <Field name="…"> finds its own. Fields register
 * their names, so the form knows which errors have nowhere to show.
 */
export type FormErrorsValue = { errors: FieldErrors; register?: (name: string) => () => void };
export const FormErrorsContext = createContext<FormErrorsValue>({ errors: {} });
